import {createAsyncThunk} from "@reduxjs/toolkit";
import { getFamilyPurchaseHistory, getActiveMemberships } from "./bitrixHistory";
import { fetchMyProfiles } from "../profileInfo/asyncActions";

import {IItem} from "./types";

export const fetchHistory = createAsyncThunk<any[]>(
  "history/fetchHistory",
  async (_, { getState, dispatch }) => {
    try {
      await dispatch(fetchMyProfiles()).unwrap();
      
      const state: any = getState();
      const myProfiles = state.getProfileInfo?.myProfiles || [];
      const partnerId = state.user?.partnerId;
      
      const partnerIds: string[] = [];
      const uniquePartnerIds = new Set<string>();
      
      if (partnerId) {
        uniquePartnerIds.add(String(partnerId));
      }
      
      myProfiles.forEach((profile: any) => {
        if (profile.partner_id) {
          uniquePartnerIds.add(String(profile.partner_id));
        }
      });
      
      partnerIds.push(...Array.from(uniquePartnerIds));

      if (partnerIds.length === 0) {
        return [];
      }

      const historyData = await getFamilyPurchaseHistory(partnerIds);
      
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      const activeItems: any[] = [];
      
      if (historyData.memberships && Array.isArray(historyData.memberships)) {
        historyData.memberships.forEach((membership: any) => {
          const finishDate = new Date(membership.finishDate);
          if (finishDate >= today) {
            const membershipName = (membership.membershipName || "").toLowerCase();
            const isFamilyType = membershipName.includes('семей') || 
                               membershipName.includes('family') ||
                               (membership.additionalOwners && membership.additionalOwners.length > 0);
            
            const familyUsers = [];
            if (isFamilyType) {
              if (membership.partnerName) {
                familyUsers.push({
                  profile: {
                    name: membership.partnerName
                  }
                });
              }
              if (membership.additionalOwners && Array.isArray(membership.additionalOwners)) {
                membership.additionalOwners.forEach((owner: any) => {
                  const ownerName = owner.partnerName || owner.name;
                  if (ownerName) {
                    const isMainOwner = membership.partnerName && ownerName === membership.partnerName;
                    if (!isMainOwner) {
                      familyUsers.push({
                        profile: {
                          name: ownerName
                        }
                      });
                    }
                  }
                });
              }
            }
            
            const savedPartnerId = membership.partnerId || membership.partner_id;
            activeItems.push({
              ...membership,
              type: "subscription",
              id: `membership_${membership.membershipId}_${membership.activationDate}`,
              partnerId: savedPartnerId,
              partner_id: savedPartnerId,
              subscription: {
                title: membership.membershipName || "Абонемент",
                type: isFamilyType ? "family" : "individual",
                includes: membership.includes || "gym,pool,sauna",
                price: membership.sum || 0,
              },
              profile: {
                name: membership.partnerName || "Пользователь",
              },
              date_from_iso: membership.activationDate,
              date_to_iso: membership.finishDate,
              expires_at: new Date(membership.finishDate).toLocaleDateString('ru-RU'),
              expiration_time: membership.finishDate,
              bought_at: new Date(membership.activationDate).toLocaleDateString('ru-RU'),
              price: membership.sum || 0,
              isDiscountPeriod: membership.isDiscountPeriod || false,
              additionalOwners: membership.additionalOwners || [],
              family: familyUsers.length > 0 ? familyUsers : undefined,
              membershipId: membership.membershipId,
            });
          }
        });
      }
      
      if (historyData.rents && Array.isArray(historyData.rents)) {
        historyData.rents.forEach((rent: any) => {
          const finishDate = new Date(rent.finishTime);
          if (finishDate >= today) {
            const startTime = new Date(rent.startTime);
            const endTime = new Date(rent.finishTime);
            
            activeItems.push({
              ...rent,
              type: "rent",
              id: `rent_${rent.courtId}_${rent.startTime}`,
              date: rent.startTime,
              time: startTime.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }),
              time_to: endTime.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }),
              hall: {
                title: `Корт`,
                id: rent.courtId,
              },
              price: rent.rentSum || 0,
            });
          }
        });
      }
      
      return activeItems;
    } catch (error) {
      throw error;
    }
  }
);

export const fetchPurchaseHistoryWithBitrix = createAsyncThunk<any>(
  "history/fetchPurchaseHistoryWithBitrix",
  async (_, { getState, dispatch }) => {
    try {
      await dispatch(fetchMyProfiles()).unwrap();
      
      const state: any = getState();
      const myProfiles = state.getProfileInfo?.myProfiles || [];
      const partnerId = state.user?.partnerId;
      
      const partnerIds: string[] = [];
      const uniquePartnerIds = new Set<string>();
      
      if (partnerId) {
        uniquePartnerIds.add(String(partnerId));
      }
      
      myProfiles.forEach((profile: any) => {
        if (profile.partner_id) {
          uniquePartnerIds.add(String(profile.partner_id));
        }
      });
      
      partnerIds.push(...Array.from(uniquePartnerIds));

      if (partnerIds.length === 0) {
        return { rents: [], memberships: [] };
      }

      const historyData = await getFamilyPurchaseHistory(partnerIds);
      
      return historyData;
    } catch (error) {
      throw error;
    }
  }
);
